import { Policy_KindEnum } from 'src/api/gen'
import { IPolicyKind, useEnabledPolicyKinds } from 'src/layout/AgencySettings'

import { FEE_RATES_POLICY_KINDS } from '../constants'

export const isFeeRate = function (kind: Policy_KindEnum): boolean {
  return FEE_RATES_POLICY_KINDS.includes(kind as any) // Because FEE_RATES_POLICY_KINDS is readonly, it only accept specific values and not any PolicyKind so we to cast it to any
}

export default (): IPolicyKind[] => {
  return useEnabledPolicyKinds().filter((policyKind) => isFeeRate(policyKind.id))
}
